import Vue from 'vue'
import store from '@/store'

export default {
  getAblyToken() {
    return Vue.http.get(`${store.getters['environment/atomicCustomerAPI']}/config/ably-token`)
  },
}
